// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__X_","cls2":"AuthorHeader-cls2_wY4 AuthorHeader-cls1__X_"};